import * as React from "react";
import type { SVGProps } from "react";
const SvgHospitalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 2C7.378 2 2 7.378 2 14s5.378 12 12 12 12-5.378 12-12S20.622 2 14 2m0 22.959C7.957 24.959 3.041 20.043 3.041 14S7.957 3.041 14 3.041 24.959 7.957 24.959 14 20.043 24.959 14 24.959"
    />
    <path
      fill="#858585"
      d="M20.246 11.398h-3.643V7.754c0-.289-.232-.52-.52-.52h-4.165c-.289 0-.52.231-.52.52v3.644H7.754c-.289 0-.52.231-.52.52v4.164c0 .29.231.52.52.52h3.644v3.644c0 .29.231.52.52.52h4.164c.29 0 .52-.23.52-.52v-3.643h3.644c.29 0 .52-.232.52-.52v-4.165c-.028-.289-.26-.52-.52-.52m-.492 4.164h-3.672c-.29 0-.52.23-.52.52v3.643h-3.123v-3.643c0-.29-.232-.52-.52-.52H8.274v-3.123h3.643c.29 0 .52-.232.52-.52V8.274h3.153v3.643c0 .29.23.52.52.52h3.643z"
    />
  </svg>
);
export default SvgHospitalIcon;
